/**
 * Resolve with `fallback` if `promise` has not settled within `ms`.
 *
 * Never rejects: a rejection of `promise` also yields `fallback`. The timer is
 * always cleared, so nothing lingers after the race is decided.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, fallback: T): Promise<T> {
  return new Promise<T>((resolve) => {
    const timer = setTimeout(() => {
      resolve(fallback);
    }, ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      () => {
        clearTimeout(timer);
        resolve(fallback);
      }
    );
  });
}
